<template>
  <div
    v-if="ifVisible"
    v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }"
  ></div>
</template>

<script>
import Vue from "vue";
import VueWaypoint from "vue-waypoint";

Vue.use(VueWaypoint);

export default {
  props: {
    category: {
      type: String,
      default: null
    },
    action: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      default: null
    },
    ifVisible: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (!this.ifVisible) this.track();
  },
  data() {
    return {
      tracked: false,
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1]
      }
    };
  },
  methods: {
    onWaypoint({ going }) {
      if (going === this.$waypointMap.GOING_IN) this.track();
    },
    track() {
      if (this.tracked) return;

      this.trackEvent({
        category: this.category,
        action: this.action,
        label: this.label,
        value: this.value,
        ...this.$attrs
      });

      this.tracked = true;
    }
  }
};
</script>
